/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Position_Types_Min1Inputs */

const vi_warehouse_position_types_min1 = /** @type {(inputs: Warehouse_Position_Types_Min1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn ít nhất 1 loại lô`)
};

/**

* @param {Warehouse_Position_Types_Min1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_position_types_min1 = /** @type {((inputs?: Warehouse_Position_Types_Min1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Position_Types_Min1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_position_types_min1(inputs)
});